/**
 * Application version – single source of truth for version tracking.
 * Bump this when releasing (e.g. 1.1, 1.2, 2.0).
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.1';
